// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@salesforce/design-system-react';

import './homepage-calendar.scss';

// TODO: change day size
// TODO: change date size
// TODO: change date weight
// TODO: day color and weight

function HomepageCalendar(props) {
  return (
    <div className="homepage-calendar">
      <div className="slds-grid slds-grid--vertical-align-center slds-m-bottom--small slds-clearfix">
        <span className="slds-text-heading--medium slds-m-right--small">{props.calendarLabel}</span>
        <span className="slds-text-title--caps">{props.dateRange}</span>
        <Button
          className="slds-container--right slds-p-left--x-small slds-p-right--x-small"
          iconName="expand_alt"
          iconCategory="utility"
          iconVariant="border"
          onClick={props.onExpandClick}
        />
      </div>

      <div className="homepage-calendar__ribbon slds-grid slds-theme--shade">{props.children}</div>
    </div>
  );
}

HomepageCalendar.displayName = 'HomepageCalendar';

HomepageCalendar.propTypes = {
  /**
   * Children for calendar. 7 CalendarDay(s) with CalendarItem(s)
   */
  children: PropTypes.node,
  /**
   * Localized "Calendar" string
   */
  calendarLabel: PropTypes.string,
  /**
   * Date range to be displayed in header. Follow this format: May 31 - Jun 6, 2016
   */
  dateRange: PropTypes.node.isRequired,
  /**
   * Callback fired when expand button is clicked
   */
  onExpandClick: PropTypes.func,
};

HomepageCalendar.defaultProps = {
  calendarLabel: 'Calendar',
};

export default HomepageCalendar;
